<template>
  <div>
    <!-- Uploader -->
    <div class="params-col">
      <div class="params-col__item">
        <el-select
          v-model="preset"
          placeholder="Select preset"
          class="param-field__select edit-select preset-field"
        >
          <el-option
            v-for="option in $options.presetOptions"
            :key="option.value"
            :label="option.label"
            :value="option.value"
          />
        </el-select>
      </div>
      <div class="params-col__item param-field">
        <file-uploader
          ref="templateUploader"
          upload-text="Upload Image"
          reset-text="Reset Uploading"
          :accept-types="['.png']"
          :size-limit-m-b="sizeLimitMB"
          @uploaded="handleFile"
          @reset="removeImage"
        />
      </div>
    </div>
    <!-- Size limit -->
    <div class="params-row params-row_justify_center upload-row">
      <span>Max size is {{ sizeLimitMB }} MB</span>
    </div>
  </div>
</template>

<script>
import FileUploader from "@/components/media/editing/FileUploader.vue";
import {
  NONE_PRESET,
  CENTER_PRESET,
  TOP_PRESET,
  BOTTOM_PRESET,
  LEFT_PRESET,
  RIGHT_PRESET,
  TOP_LEFT_PRESET,
  TOP_RIGHT_PRESET,
  BOTTOM_LEFT_PRESET,
  BOTTOM_RIGHT_PRESET,
  POSITION_PRESETS
} from "./template_presets";

// @group Editing
// Overlay image parameters
export default {
  name: "EditTemplatePanel",
  components: {
    FileUploader
  },
  model: {
    prop: "image",
    event: "update"
  },
  props: {
    // Image data
    image: {
      type: HTMLImageElement,
      default: null
    },
    // Max uploaded file size in MB
    sizeLimitMB: {
      type: Number,
      default: 5
    },
    // Position preset parameter
    positionPreset: {
      type: String,
      default: NONE_PRESET,
      validator(val) {
        return POSITION_PRESETS.includes(val);
      }
    }
  },
  /** Template position presets (with labels) */
  presetOptions: [
    {
      label: "No preset",
      value: NONE_PRESET
    },
    {
      label: "Center",
      value: CENTER_PRESET
    },
    {
      label: "Top",
      value: TOP_PRESET
    },
    {
      label: "Bottom",
      value: BOTTOM_PRESET
    },
    {
      label: "Left",
      value: LEFT_PRESET
    },
    {
      label: "Right",
      value: RIGHT_PRESET
    },
    {
      label: "Top-left",
      value: TOP_LEFT_PRESET
    },
    {
      label: "Top-right",
      value: TOP_RIGHT_PRESET
    },
    {
      label: "Bottom-left",
      value: BOTTOM_LEFT_PRESET
    },
    {
      label: "Bottom-right",
      value: BOTTOM_RIGHT_PRESET
    }
  ],
  computed: {
    preset: {
      get() {
        return this.positionPreset;
      },
      set(val) {
        this.$emit("update:positionPreset", val);
      }
    }
  },
  watch: {
    // @vuese
    // Reset upload when image cleared
    image() {
      if (this.image === null) {
        this.$refs.templateUploader.resetUploading();
      }
    }
  },
  methods: {
    // @vuese
    // Create image object from uploaded file
    handleFile({ file, approve }) {
      const url = URL.createObjectURL(file);
      const image = new Image();
      image.src = url;

      // Image updated
      this.$emit("update", image);
      // New image file uploaded
      this.$emit("imageFileUploaded", file);
      // Image added to show
      this.$emit("addTemplate");
      // Approve loading
      approve();
    },
    // @vuese
    // Clear image data
    removeImage() {
      this.$emit("update", null);
      // Image removed from to show
      this.$emit("removeTemplate");
    }
  }
};
</script>

<style scoped>
.el-button {
  width: 100%;
}
.el-button + .el-button {
  margin-left: 0;
  margin-top: 10px;
}
.upload-row {
  margin-top: 10px;
}
.preset-field {
  width: 120px;
  max-width: none;
}
</style>
